<div class="modal-header">
  <h4 class="modal-title">{{ 'pages.stock.bulkUpload.columnMapping.title' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | translate"
    data-testid="column-mapping-close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" role="dialog" aria-modal="true">
  <p class="intro">
    {{ 'pages.stock.bulkUpload.columnMapping.intro' | translate }}
  </p>

  <div *ngIf="hasEnumFields && !bannerDismissed" class="enum-banner" role="note"
    data-testid="column-mapping-enum-banner">
    <img src="assets/icons/information-circle.svg" alt="" class="enum-banner__icon" />
    <span class="enum-banner__text">
      {{ 'pages.stock.bulkUpload.columnMapping.enumBanner.text' | translate }}
    </span>
    <button type="button" class="enum-banner__close"
      [attr.aria-label]="'pages.stock.bulkUpload.columnMapping.enumBanner.dismiss' | translate"
      data-testid="column-mapping-enum-banner-dismiss" (click)="onBannerDismiss()">
      <img src="assets/icons/close.svg" alt="" />
    </button>
  </div>

  <form [formGroup]="form" class="mapping-form">
    <section *ngFor="let groupView of groupedFields; trackBy: trackByGroupKey" class="mapping-group">
      <header class="mapping-group__header" *ngIf="groupView.group as g">
        <span class="mapping-group__label">{{ groupView.groupLabel }}</span>
      </header>
      <header class="mapping-group__header" *ngIf="!groupView.group">
        <span class="mapping-group__label">
          {{ 'pages.stock.bulkUpload.columnMapping.ungroupedLabel' | translate }}
        </span>
      </header>

      <ul class="mapping-group__list">
        <li class="mapping-row" *ngFor="let item of groupView.fields; trackBy: trackByControlName">
          <div class="mapping-row__meta">
            <div class="mapping-row__label-row">
              <span class="mapping-row__label">{{ item.field.label }}</span>
              <span *ngIf="item.field.critical" class="mapping-row__critical-badge"
                [attr.aria-label]="'pages.stock.bulkUpload.columnMapping.criticalAriaLabel' | translate"
                data-testid="column-mapping-critical">*</span>
              <span class="mapping-row__type">{{ item.field.type }}</span>
            </div>
            <p class="mapping-row__help" *ngIf="item.field.help">{{ item.field.help }}</p>
          </div>

          <div class="mapping-row__control">
            <mat-form-field appearance="outline" class="mapping-row__select">
              <mat-label>
                {{ 'pages.stock.bulkUpload.columnMapping.csvHeaderLabel' | translate }}
              </mat-label>
              <mat-select [formControlName]="item.controlName"
                [attr.data-testid]="'column-mapping-select-' + item.field.property">
                <mat-option [value]="unmappedSentinel">
                  {{ 'pages.stock.bulkUpload.columnMapping.unmapped' | translate }}
                </mat-option>
                <mat-option *ngFor="let header of csvHeaders; trackBy: trackByHeader" [value]="header">
                  {{ header }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <p *ngIf="item.field.enumAcceptedText" class="mapping-row__enum-hint"
              [attr.data-testid]="'column-mapping-enum-hint-' + item.field.property">
              <img src="assets/icons/information-circle.svg" alt="" class="mapping-row__enum-hint-icon" />
              <span>{{ item.field.enumAcceptedText }}</span>
            </p>

            <div class="mapping-row__preview" *ngIf="getPreviewForProperty(item.field.property) as preview">
              <ng-container *ngIf="preview.length > 0">
                <span class="mapping-row__preview-label">
                  {{ 'pages.stock.bulkUpload.columnMapping.previewLabel' | translate }}:
                </span>
                <span class="mapping-row__preview-values">
                  <ng-container *ngFor="let value of preview; let last = last">
                    <code [class.mapping-row__preview-cell--invalid]="isInvalidEnumCell(item.field, value)"
                      [attr.title]="isInvalidEnumCell(item.field, value)
                        ? ('pages.stock.bulkUpload.columnMapping.invalidEnumTooltip' | translate)
                        : null">{{ value }}</code><span *ngIf="!last">, </span>
                  </ng-container>
                </span>
              </ng-container>
            </div>
          </div>
        </li>
      </ul>
    </section>
  </form>
</div>

<div class="modal-footer">
  <div class="missing-critical" *ngIf="missingCriticalCount > 0" data-testid="column-mapping-missing-count">
    <span class="missing-critical__text">
      {{ 'pages.stock.bulkUpload.columnMapping.missingCritical'
      | translate: { count: missingCriticalCount } }}
    </span>
  </div>
  <button type="button" class="btn btn-secondary" data-testid="column-mapping-cancel" (click)="cancel()">
    {{ 'common.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary confirm-btn" data-testid="column-mapping-confirm"
    [disabled]="!canConfirm" (click)="confirm()">
    {{ 'pages.stock.bulkUpload.columnMapping.confirm' | translate }}
  </button>
</div>